import { useAtomValue } from 'jotai'
import { routeAtom } from '@/src/stores/route-machine/atoms'
import { cn } from '@/src/utils/styles'
import ErrorHeader from './error-header'
import { RouteFromChain } from './new/from-chain'
import { FromWallet } from './new/from-wallet'
import { GasStationStepRow } from './new/gas-station-step-row'
import { RecoverRow } from './new/recover-row'
import { StepRow } from './new/step-row'
import { RouteToChain } from './new/to-chain'
import { ToWallet } from './new/to-wallet'

/**
 * List of steps and start and stop info, much like a google maps navigation route.
 */
export const StepsOverview = ({ className }: { className?: string }) => {
  const route = useAtomValue(routeAtom)

  return (
    <div className={cn('bg-foreground', className)}>
      <ErrorHeader />

      <ul className='flex flex-col px-5 pt-4'>
        <RouteFromChain />

        <GasStationStepRow />

        <FromWallet />

        {route?.signSteps.map((step) => (
          <StepRow key={step.step_number} step={step} />
        ))}

        <RecoverRow />

        <ToWallet />

        <RouteToChain />
      </ul>
    </div>
  )
}
